import { create } from 'zustand'



// Define a type for the store's state
type CategoryImageMap = Map<string, string>; // Mapping slug to imageURL
type CategoryUrlMap = Map<string, string>; // Mapping slug to url
type CategoryImageStore = {
  images: CategoryImageMap;
  urls: CategoryImageMap;
  // eslint-disable-next-line no-unused-vars
  fetchImages: (locale: string) => Promise<void>;
  // eslint-disable-next-line no-unused-vars
  getImageUrlBySlug: (slug: string) => string | undefined;
  getUrlBySlug: (slug: string) => string | undefined;
};

// Create the store
const menuImageStore: any = create<CategoryImageStore>((set, get) => ({
  images: new Map(),
  urls: new Map(),
  fetchImages: async (locale: string) => {
    // Avoid refetching if images are already populated for the current locale
    // This basic check assumes locale doesn't change frequently without page reload
    // A more robust solution might involve storing the locale for which data was fetched.
    if (get().images.size > 0) {
      console.log('Menu images already fetched, skipping refetch.');
      return;
    }
    try {
      const menuImagePath = `${process.env.NEXT_PUBLIC_LARAVEL_URL}/ecommerce-data/page-menu?region=${locale}`;
      const response = await fetch(menuImagePath);

      if (!response.ok) {
        throw new Error(`Failed to fetch menu images: ${response.statusText}`);
      }
      
      const data = await response.json();

      // Create new maps for images and URLs
      const newImages = new Map<string, string>();
      const newUrls = new Map<string, string>();

      if (Array.isArray(data)) {
         // Filter based on locale (region)
         const regionToCheck = locale === 'ca' ? 'Canada' :
         locale === 'au' ? 'Australia' :
             locale === 'nz' ? 'New Zealand' : 'International';
         
         const filteredData = data.filter((item: any) => item.regions?.includes(regionToCheck));

         // Process filtered data
         filteredData.forEach((item: { slug: string; image: string; url: string }) => {
          if (item.slug && item.image) {
            const lowerCaseSlug = item.slug.toLowerCase();
            // Prevent overwriting if multiple entries have the same slug (take the first one)
            if (!newImages.has(lowerCaseSlug)) {
                newImages.set(lowerCaseSlug, item.image);
                newUrls.set(lowerCaseSlug, item.url);
                //console.log(`Set image for ${lowerCaseSlug}:`, item.image);
            }
          }
        });
      } else {
        console.error('Invalid response format received:', data);
      }

      set({ images: newImages, urls: newUrls });
    } catch (error) {
      console.error('Error fetching menu images:', error);
      // Potentially keep old data or set to empty maps depending on desired behavior on error
      set({ images: new Map(), urls: new Map() });
    }
  },
  getImageUrlBySlug: (slug: string) => {
    const state = get(); // Use get() instead of menuImageStore.getState() inside the create function
    const imageUrl = state.images.get(slug.toLowerCase());
    // console.log(`Getting image for slug ${slug}:`, imageUrl); // Reduced logging
    return imageUrl;
  },
  getUrlBySlug: (slug: string) => {
    const state = get(); // Use get() instead of menuImageStore.getState() inside the create function
    const url = state.urls.get(slug.toLowerCase());
    // console.log(state.urls); // Reduced logging
    // console.log(`Getting url for slug ${slug}:`, url); // Reduced logging
    return url;
  },  
  
}));

export default menuImageStore;
